var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLobstrLogoBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#23024D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.079 29.2c-4.828 0-8.2-2.962-8.2-7.203 0-4.014 4.584-10.615 9.76-11.997-1.173 1.17-2.786 2.936-3.685 4.863-1.275 2.732-1.396 6.902-1.284 7.392l.18.79.765-.295a9.16 9.16 0 002.368-1.367 10.731 10.731 0 001.327-1.249c1.642-1.821 2.693-4.18 2.863-6.3 2.337 1.56 4.106 4.965 4.106 8.163 0 4.241-3.372 7.203-8.2 7.203z",
    fill: "#fff"
  })));
}
export default SvgLobstrLogoBlack;